import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppealsAndGrievancesQueueModule } from '@feature/appeals-and-grievances-queue/appeals-and-grievances-queue.module';
import { QueueModule as DmeposQueueModule } from '@products/dmepos/components/queue/queue.module';
import { SharedModule } from '@shared/shared.module';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HomeComponent } from './home.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { HHPlatformQueueModule } from '@feature/hh-platform-queue/hh-platform.module';
import { ReferralWelcomePageComponent } from './welcome-page/sdoh-welcome-page/referral-welcome-page.component';
import { WelcomeContentComponent } from './welcome-content/welcome-content.component';
import { SdohQueueComponent } from '@feature/sdoh-queue/sdoh-queue.component';
import { QueueActionButtonsComponent } from '@shared/component/queue-action-buttons/queue-action-buttons.component';

@NgModule({
  imports: [
    SharedModule,
    AppealsAndGrievancesQueueModule,
    DmeposQueueModule,
    HHPlatformQueueModule,
    WelcomeContentComponent,
    SdohQueueComponent,
    QueueActionButtonsComponent,
  ],
  declarations: [
    HomeComponent,
    WelcomePageComponent,
    ReferralWelcomePageComponent,
  ],
  providers: [ConfirmationService, MessageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule { }
